import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { useQuery } from '@apollo/react-hooks';
import colors from '../styles/colors';
import UserInfo from './UserInfo';
import BaseModal, { ModalList } from './modals/BaseModal';
import { AppContext } from '../context/AppContext';
import Loader from './Loader';
import { GET_CURRENT_USER } from '../graphql/queries';

const CardContainer = styled.div`
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  height: auto;
  width: 100%;
  background: ${colors.white};
`;

const CardHeader = styled.div`
  display: flex;
  font-size: 1.2rem;
  padding: 15px 20px;
  align-items: center;
  border-top: 1px solid ${colors.grey6};
  width: 100%;
  box-sizing: border-box;
`;

const LoaderContainer = styled.div`
  position: absolute;
  top: calc(50vh - 60px);
  left: calc(50vw - 60px);
`;

const Role = styled.div`
  font-size: 1.4rem;
  color: ${colors.grey1};
  font-weight: 500;
  display: flex;
  align-items: center;
  flex: 1;
`;

const HeaderText = styled.div`
  font-size: 1.2rem;
  color: ${colors.grey3};
  flex: ${(props) => props.flex || '1'};
`;

const MemberSince = styled.div`
  font-size: 1.4rem;
  color: ${colors.grey1};
  font-weight: 500;
  flex: 1;
`;

const UserContainer = styled.div`
  flex: 2;
`;

const Edit = styled.div`
  font-size: 1.4rem;
  color: ${colors.grey3};
  font-weight: 500;
  margin-left: 30px;
  cursor: pointer;
`;

export default function TeamTable({ roles }) {
  const [roleModalIsVisible, setRoleModalIsVisible] = useState(false);
  const { app, setApp } = useContext(AppContext);
  const { data, loading } = useQuery(GET_CURRENT_USER);

  if (loading) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    );
  }

  return (
    <>
      <BaseModal
        open={roleModalIsVisible}
        modalType={ModalList.EditRoleModal}
        onClose={setRoleModalIsVisible}
      />
      <CardContainer>
        <CardHeader>
          <HeaderText flex={2}>
            USER
          </HeaderText>
          <HeaderText>
            MEMBER SINCE
          </HeaderText>
          <HeaderText>
            ROLE
          </HeaderText>
        </CardHeader>
        {roles.map((role, index) => {
          const memberSince = role.acceptedAt ? moment(role.acceptedAt * 1000).format('MMM Do, YYYY') : 'Invite Pending';
          return (
            <CardHeader key={index}>
              <UserContainer>
                {role.userId
                  ? (
                    <UserInfo
                      firstName={role.user.firstName}
                      lastName={role.user.lastName}
                      phoneNumber={role.user.phoneNumber}
                    />
                  )
                  : (
                    <UserInfo
                      phoneNumber={role.phoneNumber}
                    />
                  )}
              </UserContainer>
              <MemberSince>
                {memberSince}
              </MemberSince>
              <Role>
                {role.accessLevel}
                {role.userId !== data.getCurrentUser._id
                && (
                <Edit onClick={() => {
                  setApp({ ...app, selectedRole: role });
                  setRoleModalIsVisible(true);
                }}
                >
                  Edit
                </Edit>
                )}
              </Role>
            </CardHeader>
          );
        })}
      </CardContainer>
    </>
  );
}
